import React from "react";
import "./atropos.css";
import Atropos from "atropos/react";
import "atropos/atropos.css";
import Codedit from "../assets/codedit334.svg";
import Gh from "../assets/github.svg";
import LinkedIn from "../assets/LinkedIn.png";
import Twitter from "../assets/Twitter.png";
import Angellist from "../assets/angellist.png";
import atTwit from "../assets/@oussedit.svg";
import OE from "../assets/Oussama Elabdioui.svg";
import Mobile_socials from "./Mobile_socials";

export const AtroposC = () => {
  return (
    <div id="socials" className="App">
      <h3>Socials:</h3>
      <p>🌍✨ Graduated from Microverse, I've journeyed through the world of full-stack development, connecting with talented minds globally. 🚀🤝 Embracing collaboration and communication as essential tools, I've learned that code unites us all. Excited to continue crafting meaningful digital experiences! 💻🌟 #MicroverseGrad #FullStackDeveloper</p>
      <div className="gridWrapper">
        <a href="https://github.com/codedit334" target="_blank">
          <Atropos className="atropos github">
            <img
              className="img1"
              data-atropos-opacity="1;1"
              data-atropos-offset="-5"
              // src="https://images.unsplash.com/photo-1634729108708-40777a48aa45?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
              // src="https://images.unsplash.com/photo-1628870184564-bea9cd9ccdb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGF0cnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
              src={Gh}
              alt="Github Logo"
            />
            <img
              data-atropos-offset="5"
              className="love"
              src={Codedit}
              alt=""
            />
          </Atropos>
        </a>
        <a
          href="https://www.linkedin.com/in/oussama-elabdioui-4677a41b6/"
          target="_blank"
        >
          <Atropos className="atropos linkedin">
            <img
              className="imgLinkedIn"
              data-atropos-opacity="1;1"
              data-atropos-offset="-5"
              // src="https://images.unsplash.com/photo-1634729108708-40777a48aa45?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
              // src="https://images.unsplash.com/photo-1628870184564-bea9cd9ccdb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGF0cnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
              src={LinkedIn}
              alt="LinkedIn Logo"
            />
            <img data-atropos-offset="5" className="love OE" src={OE} alt="" />
          </Atropos>
        </a>

        <a href="https://twitter.com/home?lang=en" target="_blank">
          <Atropos className="atropos twitter">
            <img
              className="imgTwitter"
              data-atropos-opacity="1;1"
              data-atropos-offset="-5"
              // src="https://images.unsplash.com/photo-1634729108708-40777a48aa45?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
              // src="https://images.unsplash.com/photo-1628870184564-bea9cd9ccdb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGF0cnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
              src={Twitter}
              alt="Twitter Logo"
            />
            <img
              data-atropos-offset="5"
              className="love atTwit"
              src={atTwit}
              alt=""
            />
          </Atropos>
        </a>
        <a href="https://wellfound.com/u/oussama-elabdioui">
        <Atropos className="atropos angellist">
          <img
            className="imgAngellist"
            data-atropos-opacity="1;1"
            data-atropos-offset="-5"
            // src="https://images.unsplash.com/photo-1634729108708-40777a48aa45?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
            // src="https://images.unsplash.com/photo-1628870184564-bea9cd9ccdb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGF0cnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
            src={Angellist}
            alt="Slack Logo"
          />
          <img data-atropos-offset="5" className="love OE" src={OE} alt="" />
        </Atropos>
        </a>
      </div>
      <div className="mobile-socials">
        <Mobile_socials />
      </div>
    </div>
  );
};
